import { getRequest } from '../../../api/utils/provider';
import { ApiResponse } from '../../../api/utils/responseTransform';

export type SupportType = string;

export type SupportSettingCatalogItem = {
  supportType: SupportType;
  label: string;
  tooltip: string;
  actionCopy: string;
  hasDetails: boolean;
  detailsPlaceholder?: string;
};

export type SupportSettingCategory = {
  name: 'Physical Safety' | 'Communication' | 'Environment';
  supportSettings: SupportSettingCatalogItem[];
};

export type SupportSettingsCatalogResponse = {
  categories: SupportSettingCategory[];
  detailsMaxLength: number;
};

export const getSupportSettingsCatalog = (signal?: AbortSignal): Promise<ApiResponse<SupportSettingsCatalogResponse>> =>
  getRequest<SupportSettingsCatalogResponse>('support_settings/catalog', signal);
